import React, { Component } from 'react';
import SignInStatusPanel from './components/SignInStatusPanel';
import { Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu'
import { CastForEducationTwoTone, TimelineTwoTone, PeopleAltTwoTone, AssessmentTwoTone, HowToRegTwoTone, VerifiedUserTwoTone } from '@material-ui/icons';
import RegisterMe from  './components/RegisterMe';
import Dashboard from './components/Dashboard';
import RomList from './components/RomList';
import Cycles from './components/Cycles';
import ETLForm from './components/ETLForm';
import PendingAssessments from './components/PendingAssessments';
import PendingNominations from './components/PendingNominations';
import Nominations from './components/Nominations';
import NominationHistory from './components/NominationHistory';
import Assessments from './components/Assessments';
import AssessmentHistory from './components/AssessmentHistory';
import TalentMatrixReport from './components/TalentMatrixReport';
import ThreeSixtyReport from './components/360LeadershipReport';
import AssessmentsForReview from './components/AssessmentsForReview';
import AssessmentsApproved from './components/AssessmentsApproved';
import Interventions from './components/Interventions';
import AssignInterventions from './components/AssignInterventions';
import MyInterventions from './components/InterventionsRequired';
import InterventionsForReview from './components/InterventionsForReview';
import InterventionsApproved from './components/InterventionsApproved';
import PendingInterventions from './components/PendingInterventions';
import EmployeeAssessmentsReport from './components/EmployeeAssessmentsReport';
import AggregateReport from './components/AggregateReports';
import AccessToken from './components/AccessToken';
import CyclesArchiving from './components/CyclesArchiving';
import OrphanQuery from './components/OrphanQuery';
import * as Gserv from './services/GatewayService'; //Kill at production
import AssessmentGroups from './components/AssessmentGroups';
import TalentMatrixReportByROM from './components/TalentMatrixReportByROM';
import Employees from './components/Employees';
import Qualifications from './components/Qualifications';
import EmployeeTalentProfileReport from './components/EmployeeTalentProfileReport';
import LogoRender from './components/LogoRender';
import Competencies from './components/Competencies';
import RegisteredUsers from './components/RegisteredUsers';
import ActiveEmployees from './components/ActiveEmployees';
import OHSBranchReport from './components/OHSBranchReport';
import OHSAppointments from './components/OHSAppointments';
import OHSCertificateFlags from './components/OHSCertificateFlags';
import OHSVacancies from './components/OHSVacancies';
import OHSComplianceStats from './components/OHSComplianceStats';
import OHSInjuries from './components/OHSInjuries';
import OHSInjuriesReport from './components/OHSInjuriesReport';
import OHSComplianceStatsbyBranch from './components/OHSComplianceStatsByBranch';
import MissingRegionData from './components/MissingRegionData';

export default class MainFrame extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            current_page: 'landing',
            document_array: [],
            tag: null,
            tag_type: null,
            token: null,
            just_registered: false,
            anchorEl: null,
            settings_menu_open: false,
            reports_menu_open: false,
            assessments_menu_open: false,
            nominations_menu_open: false,
            interventions_menu_open: false,
            employees_menu_open: false,
            ohs_menu_open: false,
            access_token: null,
            gserv_local: false,
        }
    }

    componentDidMount = () => {
        //set local server flag if we're working on a local dev server...
      if (Gserv.localServer()){this.setState({gserv_local:true})}
    };
    
    
    handleChildStateRequest = (new_state) => {
        if (new_state.just_registered){
            this.props.setParentState(new_state);
            this.setState({just_registered:true});
        } else {
            this.setState(new_state);
        }
    }

    openSettingsMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, settings_menu_open:true});
    };
    openReportsMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, reports_menu_open:true});
    };
    openAssessmentsMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, assessments_menu_open:true});
    };
    openNominationsMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, nominations_menu_open:true});
    };
    openInterventionsMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, interventions_menu_open:true});
    };
    openEmployeesMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, employees_menu_open:true});
    };
    openOHSMenu = (event) => {
        this.setState({anchorEl: event.currentTarget, ohs_menu_open:true});
    };

    closeMenus = () => {
        this.setState({
            anchorEl: null,
            settings_menu_open:false,
            reports_menu_open:false,
            assessments_menu_open:false,
            nominations_menu_open:false,
            interventions_menu_open:false,
            employees_menu_open:false,
            ohs_menu_open:false
        })
    }
    
    handleMenuClose = (e) => {
        const command = e.currentTarget.id;
        // console.log('command :>> ', command);

        switch (command) {

            case 'roms':
                this.closeMenus();
                this.setState({current_page:'rom_list'});
                break;
            
            case 'assessment_groups':
                this.closeMenus();
                this.setState({current_page:'assessment_groups'});
                break;

            case 'cycles':
                this.closeMenus();
                this.setState({current_page:'cycles'});
                break;

            case 'cycles_archiving':
                this.closeMenus();
                this.setState({current_page:'cycles_archiving'});
                break;
            
            case 'interventions':
                this.closeMenus();
                this.setState({current_page:'interventions'});
                break;

            case 'competencies':
                this.closeMenus();
                this.setState({current_page:'competencies'});
                break;

            case 'my_interventions':
                this.closeMenus();
                this.setState({current_page:'my_interventions'});
                break;

            case 'interventions_for_review':
                this.closeMenus();
                this.setState({current_page:'interventions_for_review'});
                break;

            case 'interventions_approved':
                this.closeMenus();
                this.setState({current_page:'interventions_approved'});
                break;
            
            case 'upload':
                this.closeMenus();
                this.setState({current_page:'upload'});
                break;

            case 'pending_assessments':
                this.closeMenus();
                this.setState({current_page:'pending_assessments_report'});
                break;

            case 'pending_nominations':
                this.closeMenus();
                this.setState({current_page:'pending_nominations_report'});
                break;

            case 'pending_interventions':
                this.closeMenus();
                this.setState({current_page:'pending_interventions_report'});
                break;

            case 'assessments_for_review':
                this.closeMenus();
                this.setState({current_page:'assessments_for_review'});
                break;

            case 'assessments_approved':
                this.closeMenus();
                this.setState({current_page:'assessments_approved'});
                break;

            case 'nominate':
                this.closeMenus();
                this.setState({current_page:'nominate'});
                break;

            case 'nomination_history':
                this.closeMenus();
                this.setState({current_page:'nomination_history'});
                break;

            case 'assess':
                this.closeMenus();
                this.setState({current_page:'assessments'});
                break;

            case 'assessment_history':
                this.closeMenus();
                this.setState({current_page:'assessment_history'});
                break;

            case 'talent_matrix':
                this.closeMenus();
                this.setState({current_page:'talent_matrix'});
                break;

            case 'talent_matrix_by_region':
                this.closeMenus();
                this.setState({current_page:'talent_matrix_by_region'});
                break;

            case 'talent_matrix_by_rom':
                this.closeMenus();
                this.setState({current_page:'talent_matrix_by_rom'});
                break;

            case '360_report':
                this.closeMenus();
                this.setState({current_page:'360_report'});
                break;

            case 'employee_assessments':
                this.closeMenus();
                this.setState({current_page:'employee_assessments'});
                break;

            case 'employee_profile':
                this.closeMenus();
                this.setState({current_page:'employee_profile'});
                break;

            case 'aggregate_report':
                this.closeMenus();
                this.setState({current_page:'aggregate_report'});
                break;
 
            case 'ohs_branch_report':
                this.closeMenus();
                this.setState({current_page:'ohs_branch_report'});
                break;
           
            case 'ohs_injuries':
                this.closeMenus();
                this.setState({current_page:'ohs_injuries'});
                break;

            case 'ohs_certificate_flags':
                this.closeMenus();
                this.setState({current_page:'ohs_certificate_flags'});
                break;

            case 'ohs_compliance_stats':
                this.closeMenus();
                this.setState({current_page:'ohs_compliance_stats'});
                break;

            case 'ohs_compliance_stats_by_branch':
                this.closeMenus();
                this.setState({current_page:'ohs_compliance_stats_by_branch'});
                break;

            case 'ohs_vacancies':
                this.closeMenus();
                this.setState({current_page:'ohs_vacancies'});
                break;

            case 'ohs_injuries_report':
                this.closeMenus();
                this.setState({current_page:'ohs_injuries_report'});
                break;
 
            case 'ohs_appointments':
                this.closeMenus();
                this.setState({current_page:'ohs_appointments'});
                break;

            case 'assign_interventions':
                this.closeMenus();
                this.setState({current_page:'assign_interventions'});
                break;

            case 'generate_token':
                this.closeMenus();
                this.setState({current_page:'generate_token'});
                break;

            case 'orphan_query':
                this.closeMenus();
                this.setState({current_page:'orphan_query'});
                break;

            case 'missing_region_query':
                this.closeMenus();
                this.setState({current_page:'missing_region_query'});
                break;

            case 'registered_users':
                this.closeMenus();
                this.setState({current_page:'registered_users'});
                break;

            case 'active_employees':
                this.closeMenus();
                this.setState({current_page:'active_employees'});
                break;

            case 'maintain_employees':
                this.closeMenus();
                this.setState({current_page:'maintain_employees'});
                break;

            case 'qualifications':
                this.closeMenus();
                this.setState({current_page:'qualifications'});
                break;

            case 'database_log':
                this.closeMenus();
                Gserv.sendCommand('getDB','DEV')
                .then(db => {
                    console.log('DB Version :>> ',db);
                });
                break;
        
            default:
                this.closeMenus();
                break;
        }

    };

    render() {return(
        <Grid 
            container
            direction='column'
            style={{
                // backgroundColor:'teal',
                minHeight:'100vh',
                overflow: 'clip'
            }}
            alignItems='center'
            justifyContent='flex-start'
            
            // spacing={2}
        >

            {/* Header panel */}
            <Grid 
                container
                direction='row'
                style={{
                    // backgroundColor:'yellow',
                    // height:'15vh',
                    minHeight:'100px',
                    overflow: 'hidden'
                    
                }}
                alignItems='center'
                justifyContent='flex-start'
            >
                <Grid 
                    item xs={5}
                    style={{
                        // backgroundColor:'violet',
                        display:'flex',
                        justifyContent:'flex-start',
                        paddingLeft:15,
                        minWidth: 420
                    }}
                >
                    <Grid
                        container
                        direction='column'
                        alignItems='baseline'
                        justifyContent='flex-start'
                        // style={{backgroundColor:'blueviolet'}}
                    >
                        <LogoRender az_qsv_banner={true}/>
                        <span>Talent Management System</span>
                        {this.props.auth_local&&
                        <span style={{color:'limegreen', fontSize:'10px'}}>Local Auth Server</span>}
                        {Gserv.localServer()&&
                        <span style={{color:'limegreen', fontSize:'10px'}}>Local Gateway Server</span>}
                    </Grid>
                </Grid>
                
                <Grid 
                    item xs={3}
                    style={{
                        // backgroundColor:'orange',
                        display: 'flex',
                        justifyContent:'space-evenly',
                        minWidth: 350,
                    }}
                >

                    {(this.props.rom||this.props.super_admin)&&
                    <div style={{paddingLeft:15}}>
                        <Tooltip title="Nominations"><IconButton aria-label='Nominations' onClick={this.openNominationsMenu}><HowToRegTwoTone fontSize='large'/></IconButton></Tooltip>
                        <Menu
                            id="nominations-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.nominations_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            <MenuItem onClick={this.handleMenuClose} id='nominate'>My Nominations</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='nomination_history'>Nomination History</MenuItem>
                        </Menu>
                    </div>}

                    <div>
                        <Tooltip title="Assessments"><IconButton aria-label='Assessments' onClick={this.openAssessmentsMenu}><AssessmentTwoTone fontSize='large'/></IconButton></Tooltip>
                        <Menu
                            id="assessments-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.assessments_menu_open}
                            onClose={this.handleMenuClose}
                        >

                            <MenuItem onClick={this.handleMenuClose} id='assess'>My Assessments</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='assessment_history'>Assessment History</MenuItem>
                            {this.props.admin&&
                            <MenuItem onClick={this.handleMenuClose} id='assessments_for_review'>Review / Approve Assessments</MenuItem>}
                            {this.props.admin&&
                            <MenuItem onClick={this.handleMenuClose} id='assessments_approved'>Assessment Approval History</MenuItem>}

                        </Menu>
                    </div>

                    <div>
                        <Tooltip title="Reports"><IconButton aria-label='Reports' onClick={this.openReportsMenu}><TimelineTwoTone fontSize='large' /></IconButton></Tooltip>
                        <Menu
                            id="reports-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.reports_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            {this.props.admin&&
                            <div>
                                <MenuItem onClick={this.handleMenuClose} id='pending_nominations'>Pending Nominations</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='pending_assessments'>Pending Assessments</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='pending_interventions'>Pending Interventions</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='360_report'>360 Leadership Reports</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='talent_matrix'>Talent Matrix Report (Individual)</MenuItem>
                                
                                {/* <MenuItem onClick={this.handleMenuClose} id='talent_matrix_by_region'>Talent Matrix Reports (by Region/Store)</MenuItem> #In progress*/}
                            </div>}

                            {(this.props.admin||this.props.rom)&&
                            <div>
                                <MenuItem onClick={this.handleMenuClose} id='talent_matrix_by_rom'>Talent Matrix Reports (by Manager)</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='employee_assessments'>Employee Assessments & Qualifications</MenuItem>
                            </div>}

                            <MenuItem onClick={this.handleMenuClose} id='employee_profile'>Employee Profile Report</MenuItem>
                            
                            {this.props.admin&&
                            <div>
                                <MenuItem onClick={this.handleMenuClose} id='aggregate_report'>Aggregate Reports by Cycle</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='ohs_certificate_flags'>OHS Certificate Alerts</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='ohs_vacancies'>OHS Vacancies by Branch</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='ohs_compliance_stats_by_branch'>OHS Compliance by Branch</MenuItem>
                                <MenuItem onClick={this.handleMenuClose} id='ohs_compliance_stats'>OHS Compliance Summary</MenuItem>
                            </div>}

                            {(this.props.admin||this.props.rom||(this.props.job_title==="BRANCH MANAGER"))&&
                            <MenuItem onClick={this.handleMenuClose} id='ohs_injuries_report'>Reported Injuries on Duty</MenuItem>}

                        </Menu>
                    </div>

                    <div>
                        <Tooltip title="Learning Interventions"><IconButton aria-label='Learning Interventions' onClick={this.openInterventionsMenu}><CastForEducationTwoTone fontSize='large' /></IconButton></Tooltip>
                        <Menu
                            id="interventions-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.interventions_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            {(this.props.admin||this.props.rom)&&
                            <MenuItem onClick={this.handleMenuClose} id='assign_interventions'>Assign Learning Interventions</MenuItem>}
                            <MenuItem onClick={this.handleMenuClose} id='my_interventions'>My Learning Interventions</MenuItem>
                            {this.props.admin&&
                            <MenuItem onClick={this.handleMenuClose} id='interventions_for_review'>Review / Approve Interventions</MenuItem>}
                            {this.props.admin&&
                            <MenuItem onClick={this.handleMenuClose} id='interventions_approved'>Intervention Approval History</MenuItem>}
                        </Menu>
                    </div>

                    {(this.props.super_admin)&&
                    <div>
                        <Tooltip title="Employees"><IconButton aria-label='Employees' onClick={this.openEmployeesMenu}><PeopleAltTwoTone fontSize='large' /></IconButton></Tooltip>
                        <Menu
                            id="employees-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.employees_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            <MenuItem onClick={this.handleMenuClose} id='maintain_employees'>Maintain Employees</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='qualifications'>Maintain Employee Qualifications</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='active_employees'>List of Active Employees</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='registered_users'>List of Registered Users</MenuItem>
                            {/* <MenuItem onClick={this.handleMenuClose} id='view_employee'>Review Employee Details</MenuItem> */}
                        </Menu>
                    </div>}

                    {(this.props.admin||this.props.rom||this.props.job_title==="BRANCH MANAGER"||this.props.job_title==="REGIONAL AREA MAN")&&
                    <div>
                        <Tooltip title="OHS"><IconButton aria-label='OHS' onClick={this.openOHSMenu}><VerifiedUserTwoTone fontSize='large' /></IconButton></Tooltip>
                        <Menu
                            id="ohs-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.ohs_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            {(this.props.admin||this.props.rom)&&
                            <MenuItem onClick={this.handleMenuClose} id='ohs_appointments'>Maintain OHS Appointments</MenuItem>}
                            
                            <MenuItem onClick={this.handleMenuClose} id='ohs_branch_report'>Branch OHS Status Report</MenuItem>
                            
                            {this.props.super_admin&&
                            <MenuItem onClick={this.handleMenuClose} id='ohs_injuries'>Log Injuries on Duty</MenuItem>}
                        </Menu>
                    </div>}
                    
                    {(this.props.super_admin)&&
                    <div>
                        <Tooltip title="Settings"><IconButton aria-label='Settings' onClick={this.openSettingsMenu}><MenuIcon fontSize='large'/></IconButton></Tooltip>
                        <Menu
                            id="settings-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.settings_menu_open}
                            onClose={this.handleMenuClose}
                        >
                            <MenuItem onClick={this.handleMenuClose} id='roms'>Designate Manager Codes</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='competencies'>Maintain Competencies</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='assessment_groups'>Maintain Assessment Groups</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='cycles'>Maintain Assessment Cycles</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='cycles_archiving'>Closing and Archiving of Assessment Cycles</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='interventions'>Maintain Learning Interventions</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='upload'>Upload Bulk Update File</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='orphan_query'>Integrity check : Invalid Manager Codes</MenuItem>
                            <MenuItem onClick={this.handleMenuClose} id='missing_region_query'>Integrity check : Missing Region Data</MenuItem>
                            {/* <MenuItem onClick={this.handleMenuClose} id='database_log'>DEV QUERY: console.log Database()</MenuItem> */}
                            {/* <MenuItem onClick={this.handleMenuClose} id='generate_token'>Generate Access Token for Excel Power Query</MenuItem> */}
                        </Menu>
                    </div>}

                </Grid>

                <Grid 
                    item xs={4}
                    style={{
                        // backgroundColor:'darksalmon',
                        display:'flex',
                        justifyContent:'flex-end',
                        paddingRight: 15,
                        // minWidth: 365
                    }}
                >
                    <SignInStatusPanel 
                        signed_in={this.props.signed_in}
                        user={this.props.user}
                        signOut = {this.props.signOut}
                        employee_name = {this.props.employee_name}
                    />
                </Grid>
            </Grid>

            {/* Main Body panel */}
            <Grid 
                container
                direction='column'
                style={{
                    // backgroundColor:'paleturquoise',
                    // height:'80vh',
                    minHeight: '200px'
                    // marginTop: 10
                }}
                justifyContent='center'
                alignItems='center'
            >

                {!this.props.registered&&!this.state.just_registered&&
                <RegisterMe
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateRequest}
                />}

                {(this.props.registered||this.state.just_registered)&&
                <div>

                    {this.state.current_page==='landing'&&
                    <Dashboard
                        gwt={this.props.gwt}
                        just_registered={this.state.just_registered}
                        admin={this.props.admin}
                        rom={this.props.rom}
                        setParentState={this.handleChildStateRequest}
                    />}

                    {this.state.current_page==='rom_list'&&
                    <RomList
                        gwt={this.props.gwt}
                    />}
                   
                    {this.state.current_page==='assessment_groups'&&
                    <AssessmentGroups
                        admin={this.props.admin}
                        super_admin={this.props.super_admin}
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='cycles'&&
                    <Cycles
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='cycles_archiving'&&
                    <CyclesArchiving
                        gwt={this.props.gwt}
                    />}
                    
                    {this.state.current_page==='interventions'&&
                    <Interventions
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='competencies'&&
                    <Competencies
                        admin={this.props.admin}
                        super_admin={this.props.super_admin}
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='my_interventions'&&
                    <MyInterventions
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='interventions_for_review'&&
                    <InterventionsForReview
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='interventions_approved'&&
                    <InterventionsApproved
                        gwt={this.props.gwt}
                    />}
                    
                    {this.state.current_page==='upload'&&
                    <ETLForm
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='pending_assessments_report'&&
                    <PendingAssessments
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='pending_nominations_report'&&
                    <PendingNominations
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='pending_interventions_report'&&
                    <PendingInterventions
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='assessments_for_review'&&
                    <AssessmentsForReview                        
                        gwt={this.props.gwt}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='assessments_approved'&&
                    <AssessmentsApproved
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='nominate'&&
                    <Nominations
                        gwt={this.props.gwt}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='nomination_history'&&
                    <NominationHistory
                        gwt={this.props.gwt}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='assessments'&&
                    <Assessments
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        super_admin={this.props.super_admin}
                        rom={this.props.rom}
                        rom_code={this.props.rom_code}
                        employee_number={this.props.employee_number}
                        employee_name={this.props.employee_name}
                    />}

                    {this.state.current_page==='assessment_history'&&
                    <AssessmentHistory
                        gwt={this.props.gwt}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='talent_matrix'&&
                    <TalentMatrixReport
                        gwt={this.props.gwt}
                    />}
                    
                    {this.state.current_page==='talent_matrix_by_rom'&&
                    <TalentMatrixReportByROM
                        gwt={this.props.gwt}
                        super_admin={this.props.super_admin}
                        rom={this.props.rom}
                        rom_code={this.props.rom_code}
                        employee_number={this.props.employee_number}
                        employee_name={this.props.employee_name}
                        admin={this.props.admin}
                    />}

                    {this.state.current_page==='360_report'&&
                    <ThreeSixtyReport
                        gwt={this.props.gwt}
                    />}
                  
                    {this.state.current_page==='orphan_query'&&
                    <OrphanQuery
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='missing_region_query'&&
                    <MissingRegionData
                        gwt={this.props.gwt}
                    />}

                    {this.state.current_page==='employee_assessments'&&
                    <EmployeeAssessmentsReport
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='employee_profile'&&
                    <EmployeeTalentProfileReport
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                        employee_number={this.props.employee_number}
                        super_admin={this.props.super_admin}
                        job_title={this.props.job_title}
                        store_code={this.props.store_code}
                    />}

                    {this.state.current_page==='aggregate_report'&&
                    <AggregateReport
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='assign_interventions'&&
                    <AssignInterventions
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='generate_token'&&
                    <AccessToken
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                        setParentState={this.handleChildStateRequest}
                        access_token={this.state.access_token}
                    />}

                    {this.state.current_page==='maintain_employees'&&
                    <Employees
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_appointments'&&
                    <OHSAppointments
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_branch_report'&&
                    <OHSBranchReport
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_injuries'&&
                    <OHSInjuries
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='ohs_injuries_report'&&
                    <OHSInjuriesReport
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                        rom_code={this.props.rom_code}
                        job_title={this.props.job_title}
                        store_code={this.props.store_code}
                        super_admin={this.props.super_admin}
                    />}

                    {this.state.current_page==='ohs_certificate_flags'&&
                    <OHSCertificateFlags
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_vacancies'&&
                    <OHSVacancies
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_compliance_stats'&&
                    <OHSComplianceStats
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='ohs_compliance_stats_by_branch'&&
                    <OHSComplianceStatsbyBranch
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='qualifications'&&
                    <Qualifications
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='registered_users'&&
                    <RegisteredUsers
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                    {this.state.current_page==='active_employees'&&
                    <ActiveEmployees
                        gwt={this.props.gwt}
                        admin={this.props.admin}
                        rom={this.props.rom}
                    />}

                </div>}

            </Grid>

            {/* Footer panel */}
            <Grid 
                container
                style={{
                    // backgroundColor:'crimson',
                    position: 'absolute',
                    bottom:'15px'
                    // height:'5vh',
                    // minHeight:'25px'
                }}
                justifyContent='center'
                alignItems='center'
            >
                {/* Show POPIA disclaimer on landing page */}
                {this.state.current_page==='landing'&&
                <div style={{border:'1px solid', width:'70%'}}><Typography><i><b>Please Note</b>: Personal information  accessed or available on the TMS is protected under the Protection of Personal Information Act 4 of 2013 ("<b>POPIA</b>") and must be treated as strictly confidential at all times. This information may not be distributed or discussed with anyone without appropriate written permission. Personal information is collected for internal purposes such as the facilitation of career development and progression monitoring, as set out in the detailed POPIA statement which has been made available to you.</i></Typography></div>}
            </Grid>

        </Grid>
    )}

}